import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendLogout } from 'src/types/backend';

const MUTATION = gql`
  mutation Logout {
    logout {
      success
    }
  }
`;

type Result = BackendLogout;

export const logout = async (authToken?: string) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    options: { authToken },
  });
  return getSingleProp<Result>(result.data);
};
